module.exports = __webpack_public_path__ + "static/assets/50bcbc9aecdcddbbb5acfd81a601c77a.gif";